@let currentLanguage = currentLanguage$ | async;

<div class="language">
  <lib-button
    #languageTrigger="libDropdownTrigger"
    buttonStyle="ghost"
    class="language__button"
    [libDropdownTrigger]="languageMenu"
  >
    {{ `language.${currentLanguage}` | translate }}
    <lib-svg-icon
      class="header__dropdown-icon"
      [icon]="languageTrigger.isOpen ? 'arrow-up' : 'arrow-down'"
    />
  </lib-button>
</div>

<ng-template #languageMenu>
  <div class="language__menu">
    @for (item of languageMenuItems; track $index) {
      <lib-button
        buttonSize="large"
        buttonStyle="ghost"
        [class.active]="item.id === currentLanguage"
        (click)="item.callback!()"
      >
        {{ item.titleTranslateKey! | translate }}
      </lib-button>
    }
  </div>
</ng-template>
